import { GROUPED_REQUEST_STATUS } from 'src/api/constants/request'
import type {
  TrackingData,
  TrackingPest,
} from 'src/api/domains/service-tracking/serviceTracking.types'
import type { GroupedRequestStatus } from 'src/api/types/requests'

import type { TreatmentEntryData } from '../constants/treatment'
import { TreatmentStatus } from '../constants/treatment'
import { resolveTreatmentBucket } from './resolveTreatmentBucket'
import { resolveTreatmentStatus } from './resolveTreatmentStatus'

/** Assigns each requested pest to a treatment bucket and resident-facing status */
export const buildTreatmentEntries = (
  requestPests: TrackingPest[],
  groupedRequestStatus: GroupedRequestStatus,
  workOrderPestsByName: TrackingData['parsedFields']['workOrderPestsByName'],
  requestNumber?: number,
): TreatmentEntryData[] => {
  const isVoided = groupedRequestStatus === GROUPED_REQUEST_STATUS.VOIDED

  return requestPests.map((pest) => {
    const workOrderPest = workOrderPestsByName[pest.name]
    const workOrder = workOrderPest?.workOrder
    const status = isVoided
      ? TreatmentStatus.Voided
      : resolveTreatmentStatus(pest.status.slug, workOrderPest?.pest.status.slug, {
          requestNumber,
          workOrderId: workOrder?.id,
          providerName: workOrder?.provider.name,
        })

    return {
      bucket: resolveTreatmentBucket(status, workOrder?.status.slug),
      pest,
      status,
    }
  })
}
